import React from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { formatNumber } from '../data';

const SeatPieChart = ({ national }) => {
  const exceeded = Math.max(national.occupied - national.total, 0);
  const slices =
    national.occupied + national.available > 0
      ? [
          { value: national.occupied, color: '#00543b' },
          { value: national.available, color: '#a4d5ac' },
        ]
      : [{ value: 1, color: '#dfe3dc' }];
  return (
    <div className="flex flex-col items-center gap-5">
      <div className="relative size-[188px]" aria-hidden="true">
        <PieChart width={188} height={188}>
          <Pie
            data={slices}
            dataKey="value"
            innerRadius={78}
            outerRadius={92}
            startAngle={90}
            endAngle={-270}
            stroke="none"
            isAnimationActive={false}
          >
            {slices.map((slice) => (
              <Cell key={slice.color} fill={slice.color} />
            ))}
          </Pie>
        </PieChart>
        <div className="absolute inset-0 flex flex-col items-center justify-center [&_strong]:text-[28px] [&_strong]:font-semibold [&_strong]:text-[#00472f] [&_span]:text-xs">
          <strong>{formatNumber(national.total)}</strong>
          <span>Places totales</span>
        </div>
      </div>
      <dl className="w-full max-w-[255px] text-[13px] [&>div]:mt-2 [&>div]:flex [&>div]:justify-between [&>div]:gap-3 [&_dt]:flex [&_dt]:items-center [&_dt]:gap-2 [&_dd]:font-semibold">
        <div>
          <dt>
            <span className="size-[9px] rounded-full bg-[#00543b]" />
            Places payées
          </dt>
          <dd>{formatNumber(national.occupied)}</dd>
        </div>
        <div>
          <dt>
            <span className="size-[9px] rounded-full bg-[#a4d5ac]" />
            Places disponibles
          </dt>
          <dd>{formatNumber(national.available)}</dd>
        </div>
      </dl>
      {national.total === 0 && national.occupied === 0 && (
        <p className="text-center text-xs text-[#586357]">Aucune place configurée</p>
      )}
      {exceeded > 0 && (
        <p className="text-center text-xs font-semibold text-[#9a3412]">
          Capacité dépassée de {formatNumber(exceeded)} place{exceeded > 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};
export default SeatPieChart;
